const ORIGINN = [
  {
    label: "广州",
    value: "1",
  },
  {
    label: "杭州",
    value: "2",
  },
];

const CITY = [
  {
    label: "广州",
    value: "1",
  },
  {
    label: "杭州",
    value: "2",
  },
  {
    label: "深圳",
    value: "3",
  },
  {
    label: "青岛",
    value: "4",
  },
];
const ACCEPT = {
  excel:
    ".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

export { ORIGINN, CITY, ACCEPT };



// WEBPACK FOOTER //
// ./src/const/CommonConst.js